import { render, staticRenderFns } from "./AppointDate.vue?vue&type=template&id=1bc60940&"
import script from "./AppointDate.vue?vue&type=script&lang=js&"
export * from "./AppointDate.vue?vue&type=script&lang=js&"
import style0 from "./AppointDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports